/* eslint-disable complexity */
import { Skeleton, Stack } from '@mui/material';
import { useIsMobile } from '@/data/hooks/useIsMobile';

export const SummarySkeleton = () => {
	const isMobile = useIsMobile();
	return (
		<Stack direction="column" spacing={0} paddingTop={'18px'}>
			<Skeleton variant="text" width={250} height={43} />
			<Stack width={'100%'} direction={isMobile ? 'column' : 'row'}>
				<Skeleton
					sx={{ marginRight: '15px' }}
					variant="text"
					width={isMobile ? '100%' : 140}
					height={100}
				/>
				<Skeleton
					sx={{ marginRight: '15px' }}
					variant="text"
					width={isMobile ? '100%' : 275}
					height={100}
				/>
				<Skeleton
					sx={{ marginRight: '15px' }}
					variant="text"
					width={isMobile ? '100%' : 350}
					height={100}
				/>
			</Stack>
			<Skeleton variant="text" width={170} height={43} />
			<Skeleton variant="text" width={'100%'} height={2} />

			<Skeleton variant="text" width={250} height={43} />
			<Skeleton variant="text" width={200} height={43} />

			<Stack width={'100%'} direction={isMobile ? 'column' : 'row'}>
				<Skeleton
					sx={{ marginRight: '15px' }}
					variant="text"
					width={isMobile ? '100%' : 275}
					height={100}
				/>
				<Skeleton
					sx={{ marginRight: '15px' }}
					variant="text"
					width={isMobile ? '100%' : 275}
					height={100}
				/>
			</Stack>
			<Stack marginBottom={'50px'}>
				<Skeleton variant="text" width={200} height={43} />
			</Stack>

			<Skeleton variant="text" width={'100%'} height={2} />

			<Skeleton variant="text" width={250} height={43} />

			<Stack width={'100%'} direction={isMobile ? 'column' : 'row'}>
				<Skeleton
					sx={{ marginRight: '15px' }}
					variant="text"
					width={isMobile ? '100%' : 275}
					height={100}
				/>
				<Skeleton
					sx={{ marginRight: '15px' }}
					variant="text"
					width={isMobile ? '100%' : 275}
					height={100}
				/>
			</Stack>
			<Skeleton variant="text" width={200} height={43} />
			<Skeleton variant="text" width={'100%'} height={2} />
			<Skeleton variant="text" width={200} height={43} />
			<Skeleton variant="text" width={'100%'} height={300} />
		</Stack>
	);
};
